<script setup>
import { CircleHelp, Search } from 'lucide-vue-next'
import InputText from 'primevue/inputtext'
import NotificationBell from '@/components/Notifications/NotificationBell.vue'
</script>

<template>
  <header class="desktop-header">
    <div class="search-box">
      <Search
        :size="20"
        :stroke-width="1.8"
      />
      <InputText
        type="text"
        :placeholder="$t('header.searchPlaceholder')"
      />
    </div>

    <div class="desktop-header-actions">
      <NotificationBell />
      <RouterLink class="icon-button" :to="{ name: 'getting-started' }" :aria-label="$t('navigation.gettingStarted')">
        <CircleHelp
          :size="21"
          :stroke-width="1.8"
        />
      </RouterLink>
    </div>
  </header>
</template>

<style scoped>
.desktop-header {
  position: sticky;
  top: 0;
  z-index: 20;
  box-sizing: border-box;
  height: 66px;
  padding: 9px 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #eeeef3;
}
.search-box {
  box-sizing: border-box;
  width: 414px;
  height: 45px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 11px;
  background: var(--surface-card);
  border: 1px solid #cacadd;
  border-radius: 8px;
}
.search-box input {
  width: 100%;
  outline: none;
  border: none;
  background: transparent;
  color: #292938;
  font-size: 16px;
}
.search-box input::placeholder {
  color: #4e4e62;
}
.desktop-header-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.icon-button {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  padding: 0;
  color: #353646;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
}
.icon-button:hover {
  background: #f3f3f7;
}
@media (max-width: 1023px) {
  .desktop-header {
    display: none;
  }
}
</style>
